export type AnaliseStatus = 'EM_ANALISE' | 'PENDENTE_DE_ESCLARECIMENTO' | 'ANALISADO';

export type AnaliseStatusNome = 'Em análise' | 'Pendente de Esclarecimento' | 'Analisado';

export const ANALISE_STATUS_NOMES: Record<AnaliseStatus, AnaliseStatusNome> = {
  EM_ANALISE: 'Em análise',
  PENDENTE_DE_ESCLARECIMENTO: 'Pendente de Esclarecimento',
  ANALISADO: 'Analisado',
};
